import React from "react";
import { Box, Typography } from "@mui/material";
import backgroundImage from "../../images/Joduella3.jpg"; // Replace with the actual image path
import { keyframes } from "@mui/system";

// Define the fade-in animation


function Thrillingone() {
  return (
    <Box
      sx={{
        position: "relative",
        height: "70vh", // Full viewport height
        backgroundImage: `url(${backgroundImage})`, // Set the background image
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        color: "white", // White text color for better contrast
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 2, // Padding for small screens
        
      }}
    >
      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay for better text visibility
          zIndex: 1,
        }}
      ></Box>

      {/* Text Content */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          maxWidth: "800px", // Limit text width
        }}
      >
        {/* Subtitle */}
        <Typography
          variant="body2"
          sx={{
            textTransform: "uppercase",
            letterSpacing: "0.15em",
            fontSize: "0.9rem",
            color: "#f3f3f3",
            mb: 2,
          }}
        >
          What to do in Knuckles
        </Typography>

        {/* Main Title */}
        <Typography
          variant="h2"
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "2.5rem", md: "3.5rem" },
            fontFamily: "'Playfair Display', serif",
            mb: 4,
          }}
        >
          Local Activities
        </Typography>

        {/* Description */}
        <Typography
          variant="body1"
          sx={{
            fontSize: "1rem",
            color: "#e0e0e0",
            lineHeight: 1.5,
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          An explorer’s paradise nestled in the heart of Sri Lanka. Trek through lush forest trails, uncover hidden waterfalls, and enjoy panoramic views from misty peaks. Experience traditional village life, kayak on serene lakes, or embark on thrilling 4x4 adventures through rugged terrains. With opportunities for hiking, birdwatching, and immersing in the rich biodiversity, Knuckles is a playground for nature and adventure lovers alike.
        </Typography>
      </Box>
    </Box>
  );
}

export default Thrillingone;
